import { render, staticRenderFns } from "./TopNavBar.vue?vue&type=template&id=4542b842&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"
import style0 from "./TopNavBar.vue?vue&type=style&index=0&id=4542b842&prod&lang=scss&scoped=true"
import style1 from "./TopNavBar.vue?vue&type=style&index=1&id=4542b842&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4542b842",
  null
  
)

export default component.exports